'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    // prevent page jumping and trigger 2 times
    setTimeout(function () {
        loadCcontent();
    }, 400);
    (0, _jquery2.default)(window).on('scroll', _jquery2.default.debounce(200, loadCcontent));
};

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _carousels = require('./carousels');

var _carousels2 = _interopRequireDefault(_carousels);

var _initialize = require('linksoft/core/initialize');

var _initialize2 = _interopRequireDefault(_initialize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isScrolledIntoView(elem) {
    var docViewBottom = (0, _jquery2.default)(window).scrollTop() + (0, _jquery2.default)(window).height();
    var elemTop = (0, _jquery2.default)(elem).offset().top - 100;

    return elemTop <= docViewBottom;
}

function loadCcontent() {
    (0, _jquery2.default)('[data-scroll-ajax]').each(function () {
        var $this = (0, _jquery2.default)(this);
        $this.data('scroll-ajax-loaded');
        if (typeof $this.data('scroll-ajax-loaded') === 'undefined') {
            $this.data('scroll-ajax-loaded', false);
        }

        var isLoaded = $this.data('scroll-ajax-loaded');

        if (isScrolledIntoView(this) && !isLoaded) {
            $this.data('scroll-ajax-loaded', true);
            _jquery2.default.ajax($this.data('scroll-ajax')).done(function (data) {
                $this.append(data);
                $this.removeClass('section-loading');
                (0, _carousels2.default)();
                _initialize2.default.trigger($this.context);
            });
        }
    });
}

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/initializers/datasScrollAjax.js
// module id = 1064
// module chunks = 0